import { render, staticRenderFns } from "./DevelopmentStage.vue?vue&type=template&id=019441c4&scoped=true&"
import script from "./DevelopmentStage.vue?vue&type=script&lang=js&"
export * from "./DevelopmentStage.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentStage.vue?vue&type=style&index=0&id=019441c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019441c4",
  null
  
)

export default component.exports